import React, { FunctionComponent } from 'react';
import { Box, useTheme } from '@material-ui/core';
import { GetCarSpecifications_carSpecifications } from '../../../../../graphql/queries/__generated__/GetCarSpecifications';
import SpecificationsDetailItem from '../../specifications/specificationsDetailItem/SpecificationsDetailItem';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import SpecificationsDetailsContainer from '../../variantSelector/specificationsModal/SpecificationsDetailsContainer';

export interface ICarSpecificationsContainerProps {
  carSpecifications: GetCarSpecifications_carSpecifications[];
  loading?: boolean;
}

const CarSpecificationsList: FunctionComponent<ICarSpecificationsContainerProps> = ({ carSpecifications, loading }) => {
  const {
    spc: {
      customise: { isSpecificationByGroup },
    },
  } = useTheme<ISpcTheme>();

  return (
    <Box data-test={'container:car_specifications'}>
      {isSpecificationByGroup ? (
        <SpecificationsDetailsContainer carSpecifications={carSpecifications} loading={loading} />
      ) : (
        carSpecifications.map((feature, index: number) => (
          <SpecificationsDetailItem key={index} category={feature?.name} specifications={feature?.specItems} />
        ))
      )}
    </Box>
  );
};

export default CarSpecificationsList;
